module.exports = __webpack_public_path__ + "static/img/SHANE_WARNE.25a687a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SHANE_WARNE.jpg
// module id = 4o2w
// module chunks = 0